import { useState, useEffect } from 'react';
import { getCampLocations } from '../firebase/firebase';

import { ReactComponent as ChautauquaArrowSVG } from './chautauqua-arrow.svg';
import styles from './component-styles.module.css';
import { notEmpty } from '..';


export function PhoneNumberInput({phoneNumber, setPhoneNumber, id}) {

    const phoneKeydownListener = (evt) => {
        if (!(evt.ctrlKey || evt.key.length > 1 || /[0-9.]/.test(evt.key)))
            evt.preventDefault();
    }

    const phoneKeyUpListener = (evt) => {
        const digits = evt.target.value.replace(/\D/g,'').substring(0,10);
        const areaCode = digits.substring(0,3);
        const prefix = digits.substring(3,6);
        const suffix = digits.substring(6,10);

        if(digits.length > 6) {evt.target.value = `(${areaCode}) ${prefix}-${suffix}`;}
        else if(digits.length > 3) {evt.target.value = `(${areaCode}) ${prefix}`;}
        else if(digits.length > 0) {evt.target.value = `(${areaCode}`;}
    }

    return (
        <input type="tel" autoComplete="tel-national" id={id}
            onChange={(e) => {setPhoneNumber(e.target.value); notEmpty(e);}} 
            onKeyDown={(e) => phoneKeydownListener(e)}
            onKeyUp={(e) => phoneKeyUpListener(e)} 
            placeholder='(123) 456-7890' defaultValue={phoneNumber}/>      
    )
}

export function LocationsSelector({setSelectedLocations, selectedLocations, dropdownVisibily, setDropdownVisibily}) {

    const [locations, setLocations] = useState([]);

    useEffect(() => {
        getCampLocations().then((locations) => {setLocations(locations)})
    }, [setLocations]);

    useEffect(() => {
        const parent = document.getElementById(styles.location_checkboxes);

        for (const element of parent.children)
            if(element.id !== styles.blocker)
                element.children[0].checked = selectedLocations.includes(element.children[0].id);
        
    }, [selectedLocations]);

    const onCheckboxChanged = (checked, location) => {
        if(checked) {
            setSelectedLocations([...selectedLocations, location])

        } else {
            let index = selectedLocations.indexOf(location);

            if(index >= 0)
                selectedLocations.splice(index, 1);

            setSelectedLocations([...selectedLocations]);
        }
    }

    var labelText = "No Locations Selected";

    if(selectedLocations.length >= 2)
        labelText = `${selectedLocations.length} Location${selectedLocations.length===1 ? '' : 's'} Selected`;
    else if (selectedLocations.length === 1)
        labelText = `${selectedLocations[0].split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`;

    const onBlockerClicked = (e) => {
        setDropdownVisibily(false);
        const underneth = document.elementsFromPoint(e.clientX, e.clientY);

        if(underneth.length > 2 && underneth[1].click !== undefined) {
            underneth[1].click();
            underneth[1].focus();
        }
    };

    return (
        <div id={styles.locations}>
            <div id={styles.location_selector} onClick={() => setDropdownVisibily(!dropdownVisibily)}>
                {labelText}
                <ChautauquaArrowSVG fill="#000000"/>
            </div>
            <div id={styles.location_checkboxes} style={{display: (dropdownVisibily) ? 'flex' : 'none'}}>
                {
                    locations.map(
                        (location) => {
                            let tag = location;
                            return (
                            <label key={tag} htmlFor={tag}>
                                <input type="checkbox" id={tag} onChange={(ev) => onCheckboxChanged(ev.target.checked, tag)}/>
                                {` ${location}`}
                            </label>)
                        }
                    )
                }
            </div>

            <div id={styles.blocker} onClick={(e) => onBlockerClicked(e)} style={{display: (dropdownVisibily) ? 'flex' : 'none'}}/>
        </div>      
    );
}